import { combineReducers } from '@reduxjs/toolkit';
import {
  articleReducer,
  authReducer,
  commissionReducer,
  doctorReducer,
  financeReducer,
  notificationReducer,
  statisticsReducer,
  userReducer,
} from './reducers';
import { contactUsReducer } from './reducers/contactUsSlice';
import { adminReducer } from './reducers/adminSlice';

export const rootReducer = combineReducers({
  auth: authReducer,
  admins: adminReducer,
  notifications: notificationReducer,
  users: userReducer,
  doctors: doctorReducer,
  finances: financeReducer,
  articles: articleReducer,
  statistics: statisticsReducer,
  contacts: contactUsReducer,
  commissions: commissionReducer,
});
